export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const DATE_RANGE_SEPARATOR = "~";
export const ADMIN_DIVISIONS_SEPARATOR = "/";
export const DIVIDED_MARK = "||";
